// extracted by mini-css-extract-plugin
export default {"wrapper":"LevelTile_wrapper__MPd-J","inactive":"LevelTile_inactive__nxpdB","data":"LevelTile_data__axWdd","dark":"LevelTile_dark__qRmnS","stars":"LevelTile_stars__zVjdB"};